<template>
  <div>
    <pp-base-header-sec></pp-base-header-sec>
    <div class="container-fluid base-container">
      <div class="base-box base-box__accordion-sec d-block d-md-flex">
        <div
          class="accordion    "
          :class="{ 'acc-sidebar': isActOpen, 'flex-fill': !isActOpen }"
          role="tablist"
        >
          <b-card
            no-body
            v-for="(item_cat, cat_index) in itemList"
            v-bind:key="item_cat.id"
            class="ac_card"
          >
            <b-card-header
              header-tag="header"
              class="ac_card-header"
              role="tab"
            >
              <b-button
                v-if="!item_cat.children || item_cat.children.length == 0"
                v-on:click="openAct(item_cat.id, item_cat.description)"
                class="btn btn-block accordion-title-btn ac_level_1-title-btn gray-title-accordian"
                variant="none"
                block
                href="#"
                v-b-toggle="'accordion-' + item_cat.id"
              >
                <span class="accordion-title-btn__text">{{
                  item_cat.description
                }}</span>
              </b-button>
              <b-button
                v-else
                class="btn btn-block accordion-title-btn ac_level_1-title-btn gray-title-accordian"
                variant="none"
                block
                href="#"
                v-b-toggle="'accordion-' + item_cat.id"
              >
                <span class="accordion-title-btn__text">{{
                  item_cat.description
                }}</span>
              </b-button>
            </b-card-header>
            <b-collapse
              :id="'accordion-' + item_cat.id"
              :visible11="isCollapseVisible(cat_index)"
              class="ac_collapse scroll_to_collapse"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body class="p-0">
                <div class="ac_collapse__item-list">
                  <b-card
                    no-body
                    v-for="item in item_cat.children"
                    v-bind:key="item.id"
                    class="ac_card"
                  >
                    <b-card-header
                      header-tag="header"
                      class="ac_card-header-level-2"
                      role="tab"
                    >
                      <a
                        v-if="!item.children || item.children.length == 0"
                        v-on:click.stop="openAct(item.id, item.description)"
                        class="btn btn-block accordion-title-btn-level-2 btn-none"
                        href="#"
                      >
                        <span class="text-not-bold">{{
                          item.description
                        }}</span>
                      </a>
                      <b-button
                        v-else
                        class="btn btn-block accordion-title-btn-level-2 btn-none"
                        variant="none"
                        block
                        href="#"
                        v-b-toggle="'accordion-' + item.id"
                      >
                        <span class="text-not-bold">{{
                          item.description
                        }}</span>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + item.id"
                      class="ac_collapse scroll_to_collapse"
                      :accordion="'accordion-' + item_cat.id"
                      role="tabpanel"
                    >
                      <ul class="ac_collapse__item-list-level-2">
                        <li
                          v-for="sub_item in item.children"
                          v-bind:key="sub_item.id"
                          class="ac_collapse__item"
                        >
                          <a
                            v-on:click.stop="
                              openAct(sub_item.id, sub_item.description)
                            "
                            :class="{ active: selectedItemId === sub_item.id }"
                            class="ac_collapse__link-level-2 accordion-item-link italic-active"
                            href="#"
                          >
                            {{ sub_item.description }}
                          </a>
                        </li>
                      </ul>
                    </b-collapse>
                  </b-card>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

        <div v-if="isActOpen" class="p-3 p-md-5 flex-fill" id="openedActsId">
          <div id="html_to_printing">
            <div class="act_header">
              <h3 class="sadrzaj-naslov-span">{{ actTitle }}</h3>
            </div>

            <div class="act-content-box" v-if="actDATA">
              <div v-if="actDATA[0].single">
                <iframe v-if="actDATA[0].actType === 'PP'"
                  height="600px"
                  width="100%"
                  :src="
                    baseApiUrl +
                      'ppp/viewDoc?uuid=' +
                      actDATA[0].lawActView.contentUrl
                  "
                  frameborder="0"
                >
                </iframe>
                <iframe v-if="actDATA[0].actType === 'REG'"
                  height="600px"
                  width="100%"
                  :src="
                    baseREGApiUrl +
                      'viewDoc?uuid=' +
                      actDATA[0].lawActView.contentUrl
                  "
                  frameborder="0"
                >
                </iframe>

              </div>
              <ul class="act-content-list" v-else>
                <li v-for="(act, index) in actDATA" v-bind:key="act.id">
                  <div class="sadrzajNadNaslov">
                    {{ act.lawActView.superscript }}
                  </div>
                  <div class="title-container">
                    <div class="list-number">{{ index + 1 }}</div>
                    <div class="normal-text">
                      <router-link
                        class="color-link underline-link  act-content__link"
                        v-if="
                          canOpen === 'can_open' &&
                            act.actType === 'REG' &&
                            act.lawActView.contentUrl === null
                        "
                        :to="
                          '/pppViewPdf/' +
                            act.lawActView.id +
                            '?doctype=' +
                            act.actType
                        "
                        target="_blank"
                      >
                        {{ act.lawActView.actKey }}
                      </router-link>
                      <router-link
                        class="color-link underline-link  act-content__link"
                        v-else-if="
                          canOpen === 'can_open' &&
                            act.actType === 'SLGLRS' &&
                            act.lawActView.contentUrl === null
                        "
                        :to="
                          '/pppViewPdf/' + act.pdfURL + '?doctype=' + act.actType
                        "
                        target="_blank"
                      >
                        {{ act.lawActView.actKey }}
                      </router-link>
                      <a
                        class="color-link underline-link  act-content__link"
                        v-else-if="canOpen === 'can_open'"
                        :href="'/ppp/viewAct/' + act.id"
                        target="_blank"
                      >
                        {{ act.lawActView.actKey }}
                      </a>
                      <a
                        class="color-link underline-link  act-content__link"
                        v-if="canOpen === 'not_logged_in'"
                        v-b-modal.login-modal
                        href="#"
                        @click.stop.prevent
                      >
                        {{ act.lawActView.actKey }}
                      </a>
                      <a
                        class="color-link underline-link  act-content__link"
                        v-if="canOpen === 'role_not_allowed'"
                        href="#"
                        @click.stop.prevent="role_not_allowed()"
                      >
                        {{ act.lawActView.actKey }}
                      </a>

                      {{ act.lawActView.actMiddleName }}
                    </div>
                  </div>
                  <div class="sadrzajOpis">{{ act.lawActView.abstract }}</div>
                  <div class="sadrzajPodNaslov">
                    {{ act.lawActView.subscript }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import PpBaseHeaderSec from "@/base_pages/pp/PpBaseHeaderSec.vue";
import { mapState } from "vuex";


export default {
  name: "PpContentPage",
  data() {
    return {
      accordionIsOpen: 0,
      selectedItemId: null,
      isActOpen: false,
      actTitle: null,
      actDATA: null,
      itemList: [],
      baseApiUrl: window.env.VUE_APP_API_PPP_DEV,
      baseREGApiUrl: window.env.VUE_APP_API_REG_DEV,
      baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik",
      },
    };
  },
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        { name: "title", content: this.meta.title },
        { name: "description", content: this.meta.description },
        { name: "keywords", content: this.meta.keywords },
      ],
    };
  },
  components: {
    PpBaseHeaderSec,
  },
  computed: {
    ...mapState(["userInfoState"]),
    canOpen() {
      if (this.userInfoState) {
        if (this.userInfoState.roles.includes(this.$route.params.extCode)) {
          return "can_open";
        } else {
          return "role_not_allowed";
        }
      } else {
        return "not_logged_in";
      }
    },
  },
  methods: {
    role_not_allowed() {
      alert("Немате приступ овој бази");
    },
    openLoginModal() {
      this.$root.$emit("bv::show::modal", "login-modal", "#btnShow");
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("html_to_printing");
    },
    selectItem(id) {
      this.accordionIsOpen = id;
    },
    openAct(actId, title = null) {
      this.actTitle = null;
      // console.log(actId);
      this.selectedItemId = null;
      this.selectedItemId = actId;
      axios
        .get(
          this.baseApiUrl +
            "ppp/acts/" +
            this.$route.params.extCode +
            "/" +
            actId
        )
        .then((response) => {
          if(response.data.length > 0)
          this.actDATA = response.data;
          else this.actDATA = null
          this.isActOpen = true;
        });
      if (title) {
        this.actTitle = title;
      }

      window.innerWidth < 992 &&
        this.$nextTick(() => {
          setTimeout(() => {
            const element = document.getElementById("openedActsId");
            element && element.scrollIntoView({ behavior: "smooth" });
          }, 100);
        });
    },
    fetchData() {
      axios
        .get(this.baseApiUrl + "ppp/menu/" + this.$route.params.extCode)
        .then((response) => {
          this.isActOpen = false;
          this.itemList = response.data;
        });
    },
    isCollapseVisible(cat_index) {
      return cat_index === 0;
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route() {
      this.fetchData();
    },
  },
  beforeCreate: function() {
    document.body.className = "color_ppp";
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
}
.title-container {
  display: flex;
}

.list-number {
  margin-right: 20px;
  padding-top: 9px;
}

.act-content-list {
  margin-left: 20px;
}

.act-content-list li .normal-text {
  margin-bottom: 5px;
  padding: 10px 15px;
  background: #f5f5f5;
  flex-basis: 100%;
}

.sadrzajNadNaslov,
.sadrzajPodNaslov {
  color: #484848 !important;
  font-family: Arial, Helvetica, sans-serif !important;
  padding: 2px 0 !important;
  font-style: italic !important;
  text-align: left !important;
  font-size: 10px !important;
  overflow-wrap: anywhere;
}

.sadrzajOpis {
  color: #484848 !important;
  font-family: Arial, Helvetica, sans-serif !important;
  padding: 0 0 0 28px !important;
  font-style: italic !important;
  text-align: left !important;
  font-size: 11px !important;
  overflow-wrap: anywhere;
}
</style>
